import { createContext, useContext } from "react";
import type { ConditionEntityHitsDto } from "../../api/types";

/**
 * Which registry entries each entity-backed leaf of the condition being edited
 * currently names, looked up by the leaf's path in the tree.
 *
 * The editor is recursive, so a leaf knows where it sits but not what the
 * request returned; `ConditionEntityHitsProvider` asks for the whole tree once
 * and answers per path.
 */
export const ConditionEntityHitsContext = createContext<
  ((path: number[]) => ConditionEntityHitsDto | undefined) | undefined
>(undefined);

export const pathKey = (path: number[]) => path.join(".");

/**
 * The hits for one leaf, or `undefined` while the first request is in flight —
 * or if the editor is rendered outside a provider, which keeps the leaf usable
 * on its own rather than throwing.
 */
export const useConditionEntityHits = (
  path: number[],
): ConditionEntityHitsDto | undefined =>
  useContext(ConditionEntityHitsContext)?.(path);
